/**
 * Tenant Directory Alpine.js Component
 * Server-rendered HTML with Alpine.js for filtering
 */

document.addEventListener('alpine:init', () => {
    Alpine.data('tenantDirectory', () => ({
        view: 'grid', // ['grid', 'list']
        
        // Filter properties
        searchQuery: '',
        selectedIndustry: '',
        selectedBuilding: '',
        selectedLetter: '',
        
        // Cached tenant cards
        tenantCards: [],

        // Initialize component
        init() {
            // Cache all tenant cards for faster filtering
            this.tenantCards = Array.from(this.$el.querySelectorAll('.tenant-card'));
            console.log('Tenant Directory initialized with', this.tenantCards.length, 'tenants');
        },

        // Check if a tenant card should be visible based on current filters
        isVisible(index) {
            const card = this.tenantCards[index];
            if (!card) return false;

            // Search filter
            if (this.searchQuery) {
                const query = this.searchQuery.toLowerCase();
                const name = card.dataset.name || '';
                const description = card.dataset.description || '';
                
                if (!name.includes(query) && !description.includes(query)) {
                    return false;
                }
            }

            // Industry filter
            if (this.selectedIndustry) {
                const industry = card.dataset.industry || '';
                if (industry !== this.selectedIndustry) {
                    return false;
                }
            }

            // Building filter
            if (this.selectedBuilding) {
                const building = card.dataset.building || '';
                if (building !== this.selectedBuilding) {
                    return false;
                }
            }

            // Letter filter
            if (this.selectedLetter) {
                const name = card.dataset.name || '';
                if (!name.startsWith(this.selectedLetter.toLowerCase())) {
                    return false;
                }
            }

            return true;
        },

        // Count of visible tenants for no-results message
        get visibleCount() {
            return this.tenantCards.filter((card, index) => this.isVisible(index)).length;
        },

        // Reset all filters
        resetFilters() {
            this.searchQuery = '';
            this.selectedIndustry = '';
            this.selectedBuilding = '';
            this.selectedLetter = '';
        }
    }));
});

console.log('Tenant Directory Alpine.js component initialized');